/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS } from '@nebular/auth';
import { getDeepFromObject } from '@nebular/auth';

import { NbAuthService } from '@nebular/auth';
import { NbAuthResult } from '@nebular/auth';

import { environment } from '../../../../environments/environment';
import { LockvueConfigProviderService } from '../../../services/lockvue-config-provider.service';

@Component({
  selector: 'lockvue-account-reset',
  styleUrls: ['./account-reset.component.scss'],
  templateUrl: './account-reset.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountResetComponent {
  showMessages: any = {};
  strategy: string = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  constructor(
    protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected router: Router,
    private configService: LockvueConfigProviderService,
  ) {
    this.showMessages = this.getConfigValue('forms.requestPassword.showMessages');
    this.strategy = this.getConfigValue('forms.requestPassword.strategy');
  }

  get clientName(): string {
    return this.configService.getDWLClientName();
  }

  requestPass(): void {
    this.errors = this.messages = [];
    this.submitted = true;

    this.service.requestPassword(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;
      if (result.isSuccess()) {
        this.messages = [
          `If an account with that email exists, you will receive an email with instructions for resetting your password.`,
          `If you can't see an email, please check your junk/spam folder.`,
          `If you don't receive an email, click 'Register' below to signup.`,
        ];
      } else {
        this.errors = result.getErrors();
      }
      this.cd.detectChanges();
    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
